import React, { useState } from 'react';
import { Box, TextV2 } from '@withjoy/joykit';
import { useTranslation } from '@shared/core';
import { EventForm } from '@shared/components/EventForm/components/data/EventForm';
import { withWindow } from '@shared/utils/withWindow';
import { AnimatedContainer } from '@website-editor/customComponents/CustomJsonComponent/components/FormDisplay/components/Form';

interface Props
  extends Readonly<{
    eventHandle: string;
    formId: string;
  }> {}

const Registration: React.FC<Props> = ({ eventHandle, formId }) => {
  const [hasSubmitted, setHasSubmitted] = useState<boolean>(false);
  const { tq } = useTranslation('formCustomComponent');
  const onComplete = () => {
    setHasSubmitted(true);
    setTimeout(() => {
      withWindow(window => {
        const url = `${window.location.origin}/${eventHandle}/registration/${formId}`;
        window.location.href = url;
      });
    }, 1500);
  };

  return (
    <Box
      width="100%"
      justifyContent="center"
      marginTop="48px"
    >
      <AnimatedContainer $isVisible={hasSubmitted}>
        <TextV2
          typographyVariant="hed3"
          textAlign="center"
        >
          {tq`Registration successful`}
        </TextV2>
      </AnimatedContainer>
      {!hasSubmitted && (
        <Box marginBottom={'64px'}>
          <TextV2
            typographyVariant="hed5"
            textAlign="center"
          >
            {tq`Event Registration`}
          </TextV2>
        </Box>
      )}
      <AnimatedContainer $isVisible={!hasSubmitted}>
        <EventForm
          formId={formId}
          onComplete={onComplete}
        />
      </AnimatedContainer>
    </Box>
  );
};

export default Registration;
